import { Scalars, Maybe } from './graphSchemaScalars';

export type TriplePlayScoreEntityInput = {
  externalIdentifier: Scalars['String'];
  name: Scalars['String'];
  year: Scalars['Int'];
  quarter: Scalars['Int'];
  scores: Array<TriplePlayScoreInput>;
  version?: Maybe<Scalars['Int']>;
};

export type TriplePlayScoreInput = {
  scoreCategory: TriplePlayScoreCategory;
  name: Scalars['String'];
  rating: Scalars['String'];
  orderValue?: Maybe<Scalars['Decimal']>;
};

export enum TriplePlayScoreCategory {
  Internet = 'INTERNET',
  InternetCall = 'INTERNET_CALL',
  InternetTelevision = 'INTERNET_TELEVISION',
  InternetTelevisionCall = 'INTERNET_TELEVISION_CALL',
}
